<template>
  <div>
    <b-card class="mb-4 reverse-bg-mode">
      <b-card-body>
        <div class="row">
          <properties-item :item="{
            label: $t('properties.chartName'),
            value: chart.meta.name,
            doubleSpan: true
          }"/>
          <properties-item v-for="(value,key) in getData" :key="key" :item="{
            label: $t(`properties.${key}`),
            value,
            doubleSpan: ['transitTime', 'transitUtc'].includes(key)
          }"/>
        </div>

      </b-card-body>
    </b-card>

<!--    <personal-chart-summary v-if="chart" :chart="{chart: getPerson}"/>-->
    <div v-if="chart.meta.person">
      <h5 class="px-2">{{chart.meta.person.name}} - {{$t('properties.foundational')}}
        <a :href="$router.resolve({name: 'single-chart', params: {
          chartId: chart.meta.person.id
        }}).href" target="_blank">{{ $t('properties.openInNewTab') }}</a>
      </h5>
      <div class="row mt-4 px-3 px-md-0">
        <summary-box v-if="chart.meta.person.birthData.time?.utc" icon="icon-time-ticking"
                     :title="$t('properties.birthDateUTC')"
                     :value="formatDate(chart.meta.person.birthData.time.utc, true) || chart.meta.person.birthData.time.timezone.id"/>
        <personal-chart-summary show-advanced :chart="getChart()" />
      </div>
    </div>

  </div>

</template>

<script>
import ChartUtil from "../../../../mixins/ChartUtil";
import { getTransitData } from "@/helpers/charts";
import PropertiesItem from "./PropertiesItem.vue";
import {computeChart} from "@/helpers/rave/api";
import docTypes from "@/helpers/docTypes";
import PersonalChartSummary from "@/components/charts/properties/summary/PersonalChartSummary.vue";
import SummaryBox from "@/components/charts/properties/summary/partials/summary-box.vue";

export default {
  components: {SummaryBox, PersonalChartSummary, PropertiesItem},

  mixins: [ChartUtil],
  props: {
    chart: Object,
  },
  computed: {
    getData() {
      return getTransitData(this.chart, this.formatDate)
    },
  },
  methods: {
    getChart(){
      return {
        meta: {
            type: docTypes.RAVE_CHART
        },
        chart: computeChart(this.chart.chart.planets.filter(x => x.chartId === 0))
      }
    }
  }
}
</script>
